import { charsheetAPI, TABLE_USERS } from '../globals.js';
import axios from 'axios';

const getCampaignCharacters = async ( campaignID ) => {
                const userTable = TABLE_USERS
                // const queryAPI = charsheetAPI + '?TableName=' + userTable + '&UserName=' + userData.uniqueUser
                const queryAPI = charsheetAPI + '?TableName=' + userTable + '&UserName=' + 'extended';
                
                const res = await axios.get( queryAPI );
                const allUsers = await res.data;
                
                // get all characters from all users in the campaign
                // return an array of objects that look like: [ characterName, userName]
                let charactersInCampaign = [];
                
                await allUsers.forEach( (user) => {
                // console.log('user:', user.username, 'campaigns:', user.campaigns);
                Object.entries(user.campaigns).forEach(([campID, campaignData]) => {
                    if (campID === campaignID) {
                        campaignData.characters.forEach((character) => {
                            charactersInCampaign.push({ characterName: character, userName: user.username });
                        });
                    }
                    });
                });


                return charactersInCampaign;
            }

export default getCampaignCharacters;